import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

import type { LeadListSource } from "../types";

async function getLeadListSources(
  workspaceId: string,
  listId: string,
): Promise<LeadListSource[]> {
  return (await get(`workspaces/${workspaceId}/lists/${listId}/source`))
    .sources;
}

/** The list's sources on their own, without the rest of the list details. */
export default function useLeadListSources({ listId }: { listId: string }) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { listsKeys } = getQueryKeys(workspaceId);

  const {
    data: leadListSources,
    isLoading: isLoadingLeadListSources,
    error: leadListSourcesError,
    refetch: refetchLeadListSources,
  } = useQuery({
    queryKey: listsKeys.sources(listId),
    queryFn: () => getLeadListSources(workspaceId, listId),
    enabled: !!listId,
  });

  return {
    leadListSources,
    isLoadingLeadListSources,
    leadListSourcesError,
    refetchLeadListSources,
  };
}
